/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Breadcrumb_HomeInputs */

const en_fw_breadcrumb_home = /** @type {(inputs: Fw_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding`)
};

const zh_fw_breadcrumb_home = /** @type {(inputs: Fw_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding" |
*
* @param {Fw_Breadcrumb_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_breadcrumb_home = /** @type {((inputs?: Fw_Breadcrumb_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Breadcrumb_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_breadcrumb_home(inputs)
	return zh_fw_breadcrumb_home(inputs)
});
export { fw_breadcrumb_home as "fw.breadcrumb.home" }